/**
 * Make the Klaviyo welcome / signup popup dismissible on mobile.
 * Klaviyo's X is type=submit, 20px, and often sits outside the card. Taps
 * either miss it or submit the empty email field instead of closing.
 */
(function () {
  'use strict';

  var DIALOG_SEL = 'div[role="dialog"][aria-label="POPUP Form"]';
  var CLOSE_SEL = '.klaviyo-close-form, [aria-label="Close dialog"]';
  var OPEN_CLASS = 'ff-welcome-popup-open';
  var LOCK_CLASS = 'klaviyo-prevent-body-scrolling';
  var MARK_KEY = 'ff-welcome-popup-closed-at';
  var LOCK_PROPS = ['overflow', 'position', 'top', 'left', 'right', 'width', 'height', 'touch-action', 'overscroll-behavior'];
  var UNLOCK_STYLE_ID = 'ff-klaviyo-scroll-unlock';
  var TEASER_SEL = '[data-testid="animated-teaser"], [class*="kl-teaser-"]';
  var wasOpen = false;
  var closing = false;
  var lockStrips = 0;

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  function clearLockStyles(el) {
    if (!el || !el.style || typeof el.style.getPropertyValue !== 'function') return;
    if (typeof el.style.removeProperty !== 'function') return;
    for (var i = 0; i < LOCK_PROPS.length; i++) {
      if (el.style.getPropertyValue(LOCK_PROPS[i])) el.style.removeProperty(LOCK_PROPS[i]);
    }
  }

  function ensureUnlockStyle() {
    if (!isMobile() || !document.head || !document.createElement || !document.getElementById) return;
    var style = document.getElementById(UNLOCK_STYLE_ID);
    if (style && style.parentNode === document.head && !style.nextSibling) return;
    if (!style) {
      style = document.createElement('style');
      style.id = UNLOCK_STYLE_ID;
      style.textContent =
        '@media (max-width:749px){' +
        'html.klaviyo-prevent-body-scrolling,html body.klaviyo-prevent-body-scrolling{' +
        'overflow:auto!important;position:static!important;top:auto!important;left:auto!important;' +
        'width:auto!important;height:auto!important;touch-action:auto!important;' +
        'overscroll-behavior:auto!important}}';
    }
    document.head.appendChild(style);
  }

  function releaseScrollLock() {
    clearLockStyles(document.documentElement);
    clearLockStyles(document.body);
    if (document.documentElement.classList.contains(LOCK_CLASS)) {
      document.documentElement.classList.remove(LOCK_CLASS);
    }
    if (document.body.classList.contains(LOCK_CLASS)) {
      document.body.classList.remove(LOCK_CLASS);
    }
  }

  function dialogEl() {
    return document.querySelector(DIALOG_SEL);
  }

  function isOpen() {
    var dialog = dialogEl();
    if (!dialog) return false;
    if (dialog.hasAttribute('hidden') || dialog.getAttribute('aria-hidden') === 'true') {
      return false;
    }
    var style = window.getComputedStyle(dialog);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.pointerEvents !== 'none';
  }

  function suppressTeasers() {
    var nodes = document.querySelectorAll(TEASER_SEL);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.getAttribute('data-ff-teaser-suppressed') === '1') continue;
      node.setAttribute('data-ff-teaser-suppressed', '1');
      node.setAttribute('hidden', '');
      node.setAttribute('aria-hidden', 'true');
      if (node.style && typeof node.style.setProperty === 'function') {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
      }
    }
  }

  function markClosed() {
    releaseScrollLock();
    suppressTeasers();
    if (document.body.classList.contains(OPEN_CLASS)) {
      document.body.classList.remove(OPEN_CLASS);
    }
    try {
      sessionStorage.setItem(MARK_KEY, String(Date.now()));
    } catch (e) {}
    if (window.FurFarExitIntent && typeof window.FurFarExitIntent.markWelcomeClosed === 'function') {
      window.FurFarExitIntent.markWelcomeClosed();
    }
    document.dispatchEvent(new CustomEvent('ff:welcome-popup-closed'));
  }

  function hardenCloseButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll(CLOSE_SEL);
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('type', 'button');
    }
  }

  function hideDialog() {
    var dialog = dialogEl();
    if (dialog) {
      dialog.setAttribute('hidden', '');
      dialog.setAttribute('aria-hidden', 'true');
      dialog.style.setProperty('display', 'none', 'important');
    }
    markClosed();
  }

  function closeWelcome(trigger) {
    if (closing) return;
    closing = true;
    if (trigger && trigger.setAttribute) {
      trigger.setAttribute('type', 'button');
    }
    window.setTimeout(function () {
      if (isOpen()) hideDialog();
      else markClosed();
      closing = false;
    }, 80);
  }

  function isNoThanks(el) {
    if (!el) return false;
    var label = ((el.getAttribute && el.getAttribute('aria-label')) || '') + ' ' + (el.textContent || '');
    return /no,?\s*thanks/i.test(label);
  }

  function onPointerDown(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var closeBtn = target.closest(CLOSE_SEL);
    if (closeBtn) closeBtn.setAttribute('type', 'button');
  }

  function onActivate(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var closeBtn = target.closest(CLOSE_SEL);
    if (closeBtn) {
      if (event.type === 'click') event.preventDefault();
      closeWelcome(closeBtn);
      return;
    }

    var action = target.closest('button, a, [role="button"]');
    if (action && isNoThanks(action) && action.closest(DIALOG_SEL)) {
      closeWelcome(action);
      return;
    }

    var dialog = dialogEl();
    if (dialog && target === dialog) {
      closeWelcome(dialog.querySelector(CLOSE_SEL) || dialog);
    }
  }

  function onKeydown(event) {
    if (event.key !== 'Escape' || !isOpen()) return;
    event.preventDefault();
    closeWelcome(dialogEl() && dialogEl().querySelector(CLOSE_SEL));
  }

  function syncOpenState() {
    var open = isOpen();
    if (open) {
      lockStrips = 0;
      // Only touch the class when it is missing. classList.add() rewrites the
      // class attribute even when the token already exists, which re-triggers
      // the MutationObserver below and locks the page in an endless loop.
      if (!document.body.classList.contains(OPEN_CLASS)) {
        document.body.classList.add(OPEN_CLASS);
      }
      hardenCloseButtons(dialogEl());
      if (isMobile()) {
        ensureUnlockStyle();
        clearLockStyles(document.documentElement);
        clearLockStyles(document.body);
      }
    } else if (wasOpen) {
      markClosed();
    } else if (
      document.body.classList.contains(LOCK_CLASS) ||
      document.documentElement.classList.contains(LOCK_CLASS)
    ) {
      /* Scroll lock with no visible form freezes the page. Strip it a few
         times, then stop so a Klaviyo re-add cannot spin the observer. */
      if (isMobile()) ensureUnlockStyle();
      if (lockStrips < 4) {
        lockStrips += 1;
        releaseScrollLock();
      }
    }
    wasOpen = open;
  }

  window.FurFarWelcomePopup = {
    isOpen: isOpen,
    close: function () {
      closeWelcome(dialogEl() && dialogEl().querySelector(CLOSE_SEL));
    }
  };

  function boot() {
    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('click', onActivate, true);
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('focusin', function () {
      if (!isMobile() || !isOpen()) return;
      ensureUnlockStyle();
      clearLockStyles(document.documentElement);
      clearLockStyles(document.body);
    }, true);
    hardenCloseButtons(document);
    suppressTeasers();
    syncOpenState();

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        suppressTeasers();
        syncOpenState();
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
